import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import ShareModal from "./ShareModal";
import PropTypes from "prop-types";
import useAppModernisation from "../../hooks/useAppModernisation";
import { usePopupPosition } from "../../hooks/popupPositionHooks/usePopupPosition";

const ShareButton = ({ open, setOpen, onClick, styling }) => {
  const [copied, setCopied] = useState(false);
  const iconRef = useRef(null);
  const [urlToShare, setUrlToShare] = useState("");
  const { isMobileView } = useAppModernisation();
  const { position } = usePopupPosition(iconRef, open);

  const iconShare = classNames("tg-icons-Share", "iconSize");

  useEffect(() => {
    setUrlToShare(window.location.href);
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(urlToShare);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy URL: ", err);
    }
  };

  return (
    <>
      <button
        type="button"
        className={styling}
        aria-label="Share link"
        ref={iconRef}
        onClick={onClick}
      >
        <i className={iconShare}></i>
      </button>

      {!isMobileView && open && (
        <ShareModal
          position={position}
          urlToShare={urlToShare}
          copied={copied}
          onClose={() => setOpen(false)}
          onCopy={handleCopy}
        />
      )}
    </>
  );
};

ShareButton.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  styling: PropTypes.string,
};

export default ShareButton;
